export function getOrCreateAppUdid(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const existing = window.localStorage.getItem("wp_app_udid");
    if (existing) return existing;
    const next = crypto.randomUUID();
    window.localStorage.setItem("wp_app_udid", next);
    return next;
  } catch (err) {
    console.warn("Unable to read/write app UDID", err);
    return null;
  }
}

export function detectDeviceOSClient(): string {
  if (typeof navigator === "undefined") return "web";
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("android")) return "web-android";
  if (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod") || ua.includes("ios")) return "web-ios";
  if (ua.includes("mac os") || ua.includes("macintosh")) return "web-macos";
  if (ua.includes("windows")) return "web-windows";
  if (ua.includes("linux")) return "web-linux";
  return "web";
}
